export const serverValidation = function (formErrors, name) {
  return () => {
    if (formErrors[name] !== undefined && formErrors[name].length > 0) {
      let ret = formErrors[name][0]
      delete formErrors[name]
      return ret
    }
  }
}

export const serverFakeValidation = function (formErrors, name) {
  return () => {
    if (formErrors[name] !== undefined && formErrors[name].length > 0) {
      let ret = formErrors[name][0]
      return ret
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/form-utils.js